import React from "react";

const Footer = () => {
    return (
        <footer className="bg-[#fbfef5] py-8 pt-12 pb-12">
            <div className="container mx-auto px-4 max-w-[85%]">
                <div className="flex flex-col md:flex-row justify-between items-start space-y-12 md:space-y-0">

                    {/* Left Column with Home and Contacts */}
                    <div className="flex flex-col md:flex-row w-full md:w-2/3 space-y-12 md:space-y-0 md:space-x-12">
                        {/* Menu Column */}
                        <div className="flex flex-col space-y-2 text-left w-full md:w-1/4">
                            <h3 className="text-lg mb-2 md:text-sm" style={{ fontSize: '18px', color: '#789a4b', fontWeight: 'normal' }}>MENU</h3>
                            <ul className="space-y-2">
                                <li><a href="/" className="text-[#789a4b]" style={{ fontSize: '16px' }}>Home Page</a></li>
                                <li><a href="/view-domains" className="text-[#789a4b]" style={{ fontSize: '16px' }}>Domini</a></li>
                                <li><a href="/chi-siamo" className="text-[#789a4b]" style={{ fontSize: '16px' }}>Chi Siamo</a></li>
                                <li><a href="/contatti" className="text-[#789a4b]" style={{ fontSize: '16px' }}>Contatti</a></li>
                                <li><a href="/faq" className="text-[#789a4b]" style={{ fontSize: '16px' }}>Faq</a></li>
                                <li><a href="/login" className="text-[#789a4b]" style={{ fontSize: '16px' }}>Login</a></li>
                                <li><a href="/register" className="text-[#789a4b]" style={{ fontSize: '16px' }}>Registrazione</a></li>
                            </ul>
                        </div>

                        {/* Contacts Column */}
                        <div className="flex flex-col space-y-2 text-left w-full md:w-3/4">
                            <h3 className="text-lg mb-2 md:text-sm" style={{ fontSize: '18px', color: '#789a4b', fontWeight: 'normal' }}>CONTATTI</h3>
                            <div className="space-y-2 text-gray-700">
                                <p className="text-sm text-[#789a4b] md:text-base lg:text-lg" style={{ fontSize: '17px' }}>Via Caldera 21 - Palazzo F, 20153 Milano MI</p>
                                <p className="text-sm text-[#789a4b] md:text-base lg:text-lg" style={{ fontSize: '17px' }}>Via Antonio Meucci 1, 63822 Porto San Giorgio FM</p>
                                <p><a href="mailto:info@vay.it" className="text-sm text-[#789a4b] md:text-base lg:text-lg" style={{ fontSize: '17px', textDecoration: 'underline' }}>info@vay.it</a></p>
                                <p><a href="tel:+3907342787" className="text-sm text-[#789a4b] md:text-base lg:text-lg" style={{ fontSize: '17px', textDecoration: 'underline'}}>+39 0734 2787</a></p>
                            </div>
                        </div>
                    </div>

                    {/* Logo Column (Aligned to the Right) */}
                    <div className="flex justify-start md:justify-end w-full md:w-1/3 mt-8 md:mt-0">
                        <img src="/static/logo-seeurl.svg" alt="Logo" className="h-12" />
                    </div>

                </div>
            </div>
        </footer>
    );
};

export default Footer;
